export default {
  link: 'https://heroes.histrf.ru/',
  previewSrc: 'heroes.png',
  title: 'Герои с вечно русским сердцем',
  announce:
    'Выставка создана Российским военно-историческим обществом при поддержке Министерства обороны Российской Федерации',
  model_type: 'specialprojectsection',
  type: 'first',
  gallery: [
    {
      previewSrc:
        'https://hero-api.histrf.ru//storage/505/conversions/%D0%91%D0%B0%D1%85%D0%B8%D1%80%D0%B5%D0%B2-%D0%92%D0%BB%D0%B0%D0%B4%D0%B8%D0%BC%D0%B8%D1%80_800-thumb.jpg',
      title: 'Владимир Бахирев',
      link: 'https://heroes.histrf.ru/info?id=1',
    },
    {
      previewSrc:
        'https://hero-api.histrf.ru//storage/543/conversions/%D0%9A%D0%B0%D0%BD%D0%B0%D0%BC%D0%B0%D1%82-%D0%91%D0%B0%D1%82%D0%B0%D1%88%D0%B5%D0%B2-thumb.jpg',
      title: 'Канамат Баташев',
      link: 'https://heroes.histrf.ru/info?id=8',
    },
    {
      previewSrc:
        'https://hero-api.histrf.ru//storage/146/conversions/%D0%A2%D0%B8%D0%BC%D0%BE%D1%84%D0%B5%D0%B8%CC%86-%D0%90%D0%BB%D0%B5%D0%BA%D1%81%D0%B5%D0%B8%CC%86%D1%87%D1%83%D0%BA-thumb.jpg',
      title: 'Тимофей Алексейчук',
      link: 'https://heroes.histrf.ru/info?id=6',
    },
    {
      previewSrc:
        'https://hero-api.histrf.ru//storage/45/conversions/%D0%92%D0%B8%D0%BA%D1%82%D0%BE%D1%80-%D0%94%D1%83%D0%B4%D0%B8%D0%BD-thumb.jpg',
      title: 'Дудин Виктор',
      link: 'https://heroes.histrf.ru/info?id=11',
    },
    {
      previewSrc:
        'https://hero-api.histrf.ru//storage/498/conversions/%D0%95%D0%BA%D0%B0%D1%82%D0%B5%D1%80%D0%B8%D0%BD%D0%B0-%D0%98%D0%B2%D0%B0%D0%BD%D0%BE%D0%B2%D0%B0_800-thumb.jpg',
      title: 'Екатерина Иванова',
      link: 'https://heroes.histrf.ru/info?id=21',
    },
    {
      previewSrc:
        'https://hero-api.histrf.ru//storage/383/conversions/%D0%9E%D0%BB%D1%8C%D0%B3%D0%B0-%D0%9A%D0%B0%D1%87%D1%83%D1%80%D0%B0_%D0%9A%D0%BE%D1%80%D1%81%D0%B0-thumb.jpg',
      title: 'Ольга Качура',
      link: 'https://heroes.histrf.ru/info?id=44',
    },
    {
      previewSrc:
        'https://hero-api.histrf.ru//storage/436/conversions/%D0%A0%D0%BE%D0%BC%D0%B0%D0%BD-%D0%9A%D0%BE%D0%B1%D0%B5%D1%86_01-thumb.jpg',
      title: 'Роман Кобец',
      link: 'https://heroes.histrf.ru/info?id=76',
    },
    {
      previewSrc:
        'https://hero-api.histrf.ru//storage/590/conversions/%D0%93%D0%9B%D0%90%D0%92%D0%9D%D0%90%D0%AF_%D0%9A%D0%BE%D0%BF%D1%8B%D0%BB%D0%BE%D0%B2-%D0%90%D0%BB%D0%B5%D0%BA%D1%81%D0%B0%D0%BD%D0%B4%D1%802-standard-scale-4_00x-gigapixel-thumb-thumb.jpg',
      title: 'Александр Копылов',
      link: 'https://heroes.histrf.ru/info?id=65',
    },
  ],
};
